<template>
  <v-list>
    <template v-if="auth.user.value!.is_superuser">
      <v-list-subheader title="Admin Area" class="mt-8" />
      <v-divider />
      <v-list-item href="/admin/" title="Administration" prepend-icon="mdi-file-document" />
      <v-list-item to="/monitoring/" title="Monitoring" prepend-icon="mdi-biohazard" />
      <v-list-item to="/order-integrity/" title="Order Integrity" prepend-icon="mdi-shield-search" />
    </template>
  </v-list>
</template>

<script setup lang="ts">
const auth = useAuth();
</script>
